import {
  LayoutDashboard,
  Users,
  Shield,
  AppWindow,
  Activity,
  AlertTriangle,
  Sliders,
  LayoutTemplate,
  Server,
  Bot,
  BarChart3,
  MessageSquareWarning,
} from 'lucide-react'

export interface AdminNavItem {
  path: string
  label: string
  icon: React.ElementType
  /** RBAC permission that gates the page. `null` marks the aggregate Overview. */
  perm: string | null
}

// Each admin nav item declares the RBAC permission that gates its page. The
// section + items are filtered by useCan() so a non-admin who holds a single
// permission sees only the screens they can actually use. is_admin always
// passes (master override in useCan), so admins keep the full list. Backend
// require_permission remains the true enforcement boundary for the page data.
// `perm: null` marks the Overview dashboard, which aggregates several areas and
// has no single gate; its visibility is decided by shouldShowOverview()
// (see lib/adminOverview.ts), and AdminIndex sends single-area grantees straight
// to their one screen instead. Shared by Layout (nav) and AdminIndex (landing).
export const adminNavItems: AdminNavItem[] = [
  { path: '/admin', label: 'Overview', icon: LayoutDashboard, perm: null },
  { path: '/admin/users', label: 'Users', icon: Users, perm: 'users.read' },
  { path: '/admin/roles', label: 'Roles', icon: Shield, perm: 'roles.read' },
  { path: '/admin/apps', label: 'Apps', icon: AppWindow, perm: 'apps.read' },
  { path: '/admin/activity', label: 'Activity', icon: Activity, perm: 'audit.read' },
  { path: '/admin/secret-findings', label: 'Secret Findings', icon: AlertTriangle, perm: 'secrets.read' },
  { path: '/admin/app-store-moderation', label: 'App Reports', icon: MessageSquareWarning, perm: 'app_store.moderation.read' },
  { path: '/admin/platform-settings', label: 'Platform Settings', icon: Sliders, perm: 'platform_settings.read' },
  { path: '/admin/templates', label: 'Templates', icon: LayoutTemplate, perm: 'templates.read' },
  { path: '/admin/resource-limits', label: 'Resource Limits', icon: Server, perm: 'platform_settings.read' },
  { path: '/admin/claude-code', label: 'Claude Code', icon: Bot, perm: 'config.read' },
  { path: '/admin/analytics', label: 'Analytics', icon: BarChart3, perm: 'analytics.read' },
  { path: '/admin/analytics/system', label: 'System Health', icon: Activity, perm: 'diagnostics.read' },
]
